import { isToday, parseISO } from 'date-fns';
import { useMemo } from 'react';
export const useOpeningHours = ({
  defaultOpeningHours,
  specialOpeningHours
}) => {
  const {
    timeFrom,
    timeUntil
  } = specialOpeningHours?.find(specialTimes => isToday(parseISO(specialTimes.date))) ?? defaultOpeningHours;
  return useMemo(() => ({
    short: {
      timeFrom: timeFrom.replace(/^0|:00/g, ''),
      timeUntil: timeUntil.replace(/^0|:00/g, '')
    },
    long: {
      timeFrom,
      timeUntil
    }
  }), [timeFrom, timeUntil]);
};